

export const discoverGeorgesConfig = [
    {
        title: "How to start with Georges ?",
        icon: "bi bi-question-circle",
        steps: [
            {
                title: "Georges",
                text: "I am a GenAI powered chatbot that can search and efficiently synthesize Infravia’s internal knowledge.",
            },
            {
                title: "Documents",
                text: "You can select and filter files and documents here.",
                action: "Open Filters and select documents Menu"
            },
            {
                title: "Chat",
                text: "Use the chat to ask anything to Georges.",
                action: "See some prompts examples here"
            },
            {
                title: "Modes",
                text: "Now let me present you what I can do",
                action: "Modes training"
            },
        ]
    },
    {
        title: "Georges's modes",
        icon: "bi bi-chat",
        steps: [
                {
                    title: "Modes",
                    icon: "xx",
                    text: "You can select modes below the Chat bar. If you don't select any mode, Georges will choose for you.",
                },
                {
                    title: "Search Infravia",
                    icon: "bi bi-database",
                    text: "Search for information in the documents you selected",
                    action: "Set Mode Search Infravia"
                },
                {
                    title: "Everyday chat",
                    icon: "bi bi-chat",
                    text: "Synthesize information from the documents",
                    action: "Set Mode Generalist Chat"
                },
                {
                    title: "Advanced search on the web, no professional data",
                    icon: "bi bi-globe",
                    text: "Get internet information",
                    action: "Set Mode Explore"
                },
                {
                    title: "Chat with your docs",
                    icon: "bi bi-folder",
                    text: "XXX",
                    action: "Chat with your Docs presentation"
                }
        ]
    },
    {
        title: "Uploading documents",
        icon: "bi bi-file-earmark-text",
        steps: [
                {
                    title: "Click on 'Chat with my docs' mode",
                    text: "Just below the Chat bar. It will open the menu with your documents.",
                    action: "Set Mode Chat with your docs"
                },
                {
                    title: "Click on Upload a document button",
                    text: "You can only select a PDF file",
                },
                {
                    title: "Wait for upload",
                    text: "When upload is over, you will get a notification.",
                    action: "Follow your uploads"
                },
                {
                    title: "Summarizing",
                    text: "After upload, Georges will automatically summarize the document. It will take some time.",
                    action: "Follow the summarizing"
                },
                {
                    title: "Chat with your doc",
                    text: "You can now chat with your doc. You can ask anything about the document. BY selecting it in the menu.",
                    action: "Open my documents"
                }
            ]
    },
    {
        title: "Summarizing documents",
        icon: "bi bi-file-earmark-text",
        steps: [
            {
                title: "Synthetize documents",
                text: "Georges can summarize any document, from Infravia database, or from your uploads.",
            },
            {
                title: "Go on Search Infravia",
                action: "Set Mode Search Infravia"
            },
            {
                title: "Launch the summary",
                text: "On any document, click on the small icon on the right of the document name. If the summary is not yet available, Georges will ask you if you want to generate it.",
                action: "Open Filters and select documents Menu"
            },
            {
                title: "Wait for the summary",
                text: "It will take some time.",
                action: "Follow the summarizing"
            },
            {
                title: "View summary",
                text: "The summary will be available with the same icon at the right of the document name.",
                action: "Open Filters and select documents Menu"
            },
            {
                title: "Summarize my documents",
                text: "For documents that you upload, Georges will automatically generate a summary.",
                action: "Set Mode Chat with your docs"
            },
            {
                title: "View a summary and deep-dive",
                action: "View a summary and deep-dive training"
            }

        ]
    },
    {
        title: "View a document summary and deep-dive",
        icon: "bi bi-search",
        steps: [
            {
                title: "Go on Chat with your docs Mode",
                action: "Set Mode Chat with your docs"
            },
            {
                title: "Select a document",
                action: "Open Filters and select documents Menu"
            },
            {
                title: "Open a document summary which is available",
                text: "It should show a Show summary and deep-dive button on the upper right side"
            },
            {
                title: "Click to show the summary while chatting",
                text: "You can use the summary to see themes covered by the document and then ask Georges some questions about it."
            }
        ]
    },
    {
        title: "Translate a document",
        icon: "bi bi-phone",
        steps: [
            {
                title: "Use DeepL PRO",
                text: "Georges is a knowledge agent, and performs less good than DeepL on document translation. Even if the document is an image, DeepL can translate it."
            }
        ]
    }
]
